__turbopack_context__.v({
  "className": "poppins_5721e859-module__9ft-tG__className",
});
